/**
 * Composant podium (classement top 3) pour le lecteur d'overlays standalone.
 * Responsabilité unique : afficher le classement avec animations d'entrée/sortie.
 */

import React from 'react';
import { LEADERBOARD_TOP_COUNT } from './constants';

/**
 * Retourne le libellé du titre du podium (évite doublon "Classement Classement X").
 * @param {string} rewardName
 * @returns {string}
 */
export function getLeaderboardTitle(rewardName) {
  if (!rewardName || !rewardName.trim()) return '';
  const trimmed = rewardName.trim();
  if (trimmed.toLowerCase().startsWith('classement ')) return trimmed;
  return `Classement ${trimmed}`;
}

/**
 * Entrée du podium : user_display_name ou user_login.
 * @param {{ user_display_name?: string, user_login?: string }} entry
 * @returns {string}
 */
function getEntryDisplayName(entry) {
  return entry?.user_display_name || entry?.user_login || '';
}

/**
 * Podium overlay (top 3) avec slots 2e à gauche, 1er au centre, 3e à droite.
 * @param {{
 *   entries: Array<{ user_display_name?: string, user_login?: string, value?: string|number }>,
 *   rewardName: string,
 *   entering?: boolean,
 *   exiting?: boolean
 * }} props
 */
export function OverlayLeaderboardPodium({
  entries = [],
  rewardName = '',
  entering = false,
  exiting = false,
}) {
  const topEntries = Array.isArray(entries)
    ? entries.slice(0, LEADERBOARD_TOP_COUNT)
    : [];

  return (
    <div
      className={`overlayLeaderboardPodium ${
        entering ? 'overlayLeaderboardPodium--entering' : ''
      } ${exiting ? 'overlayLeaderboardPodium--exiting' : ''}`}
    >
      {rewardName && (
        <div className="overlayLeaderboardPodiumTitle">
          {getLeaderboardTitle(rewardName)}
        </div>
      )}
      {topEntries.length === 0 ? (
        <div className="overlayLeaderboardPodiumEmpty">
          Aucun joueur pour l&apos;instant
        </div>
      ) : (
        <div className="overlayLeaderboardPodiumInner">
          {topEntries.length >= 2 && (
            <div className="overlayLeaderboardPodiumSlot overlayLeaderboardPodiumSlot--second">
              <span className="overlayLeaderboardPodiumRank">2</span>
              <span className="overlayLeaderboardPodiumName">
                {getEntryDisplayName(topEntries[1])}
              </span>
              <span className="overlayLeaderboardPodiumValue">
                {topEntries[1].value}
              </span>
            </div>
          )}
          <div className="overlayLeaderboardPodiumSlot overlayLeaderboardPodiumSlot--first">
            <span className="overlayLeaderboardPodiumStar" aria-hidden>
              ★
            </span>
            <span className="overlayLeaderboardPodiumRank">1</span>
            <span className="overlayLeaderboardPodiumName">
              {getEntryDisplayName(topEntries[0])}
            </span>
            <span className="overlayLeaderboardPodiumValue">
              {topEntries[0].value}
            </span>
          </div>
          {topEntries.length >= 3 && (
            <div className="overlayLeaderboardPodiumSlot overlayLeaderboardPodiumSlot--third">
              <span className="overlayLeaderboardPodiumRank">3</span>
              <span className="overlayLeaderboardPodiumName">
                {getEntryDisplayName(topEntries[2])}
              </span>
              <span className="overlayLeaderboardPodiumValue">
                {topEntries[2].value}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
